import cn from "classnames";
import type { ComponentProps, FC, PropsWithChildren } from "react";
import { Container } from "react-bootstrap";

const EmptyContainer: FC<PropsWithChildren> = (props) => {
	return <Container className="empty-container">{props.children}</Container>;
};

const Empty: FC<ComponentProps<"div">> = (props) => {
	const { children, className, ...rest } = props;
	return (
		<div className={cn("empty", className)} {...rest}>
			{children}
		</div>
	);
};

const EmptyHeader: FC<PropsWithChildren> = (props) => {
	return <div className="empty-header">{props.children}</div>;
};

const EmptyTitle: FC<ComponentProps<"div">> = (props) => {
	const { className, ...rest } = props;

	return <p className={cn("empty-title", className)} {...rest} />;
};

const EmptyNamespace = Object.assign(Empty, {
	Header: EmptyHeader,
	Title: EmptyTitle,
	Container: EmptyContainer,
});

interface EmptyPageProps extends PropsWithChildren {
	title: string;
}

export const EmptyPage: FC<EmptyPageProps> = (props) => {
	return (
		<>
			<title>{props.title}</title>
			{props.children}
		</>
	);
};

export { EmptyNamespace as Empty };
